import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { AddCategory } from "../AddCategory";

const InitMiddlewareAddCategory:React.FC<any> = (props) => {
  const { addCategory, isSuccess } = useSelector(
    (state: any) => state.rootReducer?.category
  );
  const navigate = useNavigate();

  useEffect(() => {
    const data: any = [
      {
        label: "Categories",
        link: `/categories`,
      },
      {
        label: "Add new category",
        link: ``,
      },
    ];
    store.dispatch(addBreadcrumb(data));
  }, []);
  

  if (isSuccess && addCategory?.data?.success === true) {
    navigate("/categories")
    return null;
  } else {
    return <AddCategory {...props} />;
  }
};

export default InitMiddlewareAddCategory;
